import { put, call, takeLatest, select } from 'redux-saga/effects';
import _get from 'lodash/get';
import { replace } from 'connected-react-router';

import ActionTypes from '../constants/ActionTypes';
import {
  uploadCustomFormFileUpload,
  addOnboardingData,
  setOnboarded,
} from '../api/onboarding';
import { progressStart, progressStop } from '../actions';
import {
  showErrorToast,
  showInfoToast,
  showWarningToast,
} from '../actions/toast';
import { getApiErrorData } from '../utils/helperFunction';

function* uploadCustomFormFile(args) {
  try {
    yield put(progressStart());
    const payload = new FormData();
    payload.append('file', args.file);
    payload.append('upload_type', 'generic');
    payload.append('filename_prefix', '');
    payload.append('name', args.file.name);
    payload.append('source', 'candidate_upload');

    const { size } = args.file;
    const _10MBinBytes = 10 * 1000 * 1000;
    if (size > _10MBinBytes) {
      yield put(showWarningToast('File size should be less than 10 MB'));
      return;
    }
    yield put(showInfoToast('Upload in progress. Please wait...'));
    const resp = yield call(uploadCustomFormFileUpload, payload);
    const url = _get(resp, 'data.resource_uri');
    yield put({
      type: `${ActionTypes.CUSTOM_FORM_UPLOAD_FILE}_SUCCESS`,
      id: args.id,
      payload: url,
    });
  } catch (e) {
    const { toast } = yield select(state => state.appStatus);
    const errorInfo = getApiErrorData(e, 'FUP');
    if (errorInfo && errorInfo.message && !toast?.apiErrorInfo) {
      yield put(showErrorToast(errorInfo.message, errorInfo.apiErrorInfo));
    }
  } finally {
    yield put(progressStop());
  }
}
function* submitCustomForm(args) {
  try {
    yield put(progressStart());
    // const test = yield select(state => state.test);
    // const hasProfileOnboarding = _get(test, 'settings.hacker_extra_data.profile_data');

    yield call(addOnboardingData, args.inviteId, args.payload);
    yield call(setOnboarded);

    // if (hasProfileOnboarding) {
    //   yield put(replace(`/test/${args.testSlug}/`));
    // } else {
    yield put(replace(`/test/${args.testSlug}`));
    // }
  } catch (e) {
    const { toast } = yield select(state => state.appStatus);
    let errorInfo = {};
    if (e?.config?.url?.includes('invite.add_extra_data')) {
      errorInfo = getApiErrorData(e, 'AED');
    } else if (e?.config?.url?.includes('user.onboarded')) {
      errorInfo = getApiErrorData(e, 'ONB');
    }
    if (errorInfo && errorInfo.message && !toast?.apiErrorInfo) {
      yield put(showErrorToast(errorInfo.message, errorInfo.apiErrorInfo));
    }
  } finally {
    yield put(progressStop());
  }
}
export default function* loadAuthSaga() {
  yield takeLatest(ActionTypes.CUSTOM_FORM_UPLOAD_FILE, uploadCustomFormFile);
  yield takeLatest(ActionTypes.SUBMIT_CUSTOM_FORM, submitCustomForm);
}
